var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.movieDetail
    ? _c("div", { staticClass: "c-movie__desc__col" }, [
        _c("h3", { staticClass: "c-movie__title" }, [
          _vm._v(_vm._s(_vm._f("titleCase")(_vm.movieDetail.Title)))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-movie__info" }, [
          _c("p", { staticClass: "c-movie__info__items c-movie__info--rate" }, [
            _vm._v(_vm._s(_vm.movieDetail.Rating))
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-movie__info__items c-movie__info--time" }, [
            _vm._v(_vm._s(_vm.time))
          ]),
          _vm._v(" "),
          _vm.showTrailer && _vm.movieDetail.TrailerUrl
            ? _c(
                "p",
                { staticClass: "c-movie__info__items c-movie__info--trailer" },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "8",
                        height: "10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M.5 9.263V.737L6.682 5 .5 9.263z",
                          stroke: "#444"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "silentbox-single",
                    {
                      attrs: {
                        autoplay: true,
                        src:
                          _vm.movieDetail.TrailerUrl ||
                          "https://www.youtube.com/watch?v=wmiIUN-7qhE",
                        description: _vm.movieDetail.name
                      }
                    },
                    [_vm._v("\n        trailer\n      ")]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "c-movie__description",
            domProps: { innerHTML: _vm._s(_vm.movieDetail.Description) }
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.movieDetail.Description || _vm.defaultDesc) +
                "\n  "
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }